import { DataUnitStatsItem, SourceTotal, DataUnit } from '../types';
import { client } from './axiosClient';

export const confirmDataUnit = async (company_id: string, duId: number) => {
  const res = await client.post(
    `/client/data-units/${duId}/confirm`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getDataUnitsStats = async (
  company_id: string | undefined,
  from: string | undefined,
  to: string | undefined
) => {
  const res = await client.get<DataUnitStatsItem[]>(
    '/client/data-units/stats',
    {
      params: {
        company_id,
        from,
        to,
      },
    }
  );
  return res.data;
};

export const getDataUntisSourceTotals = async (
  company_id: string | undefined,
  id: number
) => {
  const res = await client.get<SourceTotal[]>(
    `/client/invoice-documents/data-units/${id}/source-totals`,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getDataUnits = async (
  company_id: string,
  controller?: AbortController
) => {
  const res = await client.get<DataUnit[]>('/client/data-units', {
    signal: controller?.signal,
    params: {
      company_id,
    },
  });
  return res.data.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
};
